







































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import formatDate from "@/lib/formatDate";
import PrintTable from "@/basics/table/PrintTable.vue";

@Component({ components: { CButton, PrintTable } })
export default class TelKey extends Vue {
  get start(): string {
    const u = Number(this.$route.query.start);
    return formatDate(new Date(u));
  }

  get end(): string {
    const u = Number(this.$route.query.end);
    return formatDate(new Date(u));
  }

  get callId(): string {
    const id = this.$route.query.callId;
    return `${id.slice(0, 4)}-${id.slice(4, 8)}`;
  }

  get tel(): string {
    return this.$route.query.tel as string;
  }

  get openId(): string {
    return `${this.callId}-1`;
  }

  get closeId(): string {
    return `${this.callId}-9`;
  }

  print() {
    window.print();
  }
}
